export const originalTab = () => {
  const tabSet = document.querySelector('.js-tabs'); // ← 複数想定しない場合、1セットでOK
  if (!tabSet) return;

  const buttons = tabSet.querySelectorAll('.tab-button');
  const contents = tabSet.querySelectorAll('.tab-content');

  if (!buttons.length || !contents.length) {
    console.warn('タブセットが正しくありません。スクリプトはスキップされました。');
    return;
  }

  // クエリパラメータ（例：?contact）のキー名を取得
  const getTabFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    const entries = Array.from(params.entries());

    const validTabIds = Array.from(buttons)
      .map((btn) => btn.dataset.tab)
      .filter((id) => typeof id === 'string' && id.length > 0);

    for (const [key] of entries) {
      if (validTabIds.includes(key)) {
        return key;
      }
    }

    // なければ最初のタブの data-tab を返す
    return buttons[0]?.dataset.tab || '';
  };

  // 履歴保持が必要なページかどうかを判定
  const shouldUseHistory = document.querySelector('main.guide') !== null;

  const activateTab = (tabId, addToHistory = false) => {
    buttons.forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.tab === tabId);
    });
    contents.forEach((content) => {
      content.classList.toggle('active', content.id === tabId);
    });

    // URLにハッシュ値を追加（履歴に追加する場合、かつmain.guideがある場合のみ）
    if (addToHistory && shouldUseHistory) {
      history.pushState(null, '', `#${tabId}`);
    }

    // タブ切り替え時にスクロール位置を「パッと」移動
    if (tabSet.classList.contains('scroll-position-move')) {
      const activeContent = tabSet.querySelector(`#${tabId}`);
      if (activeContent) {
        // 一時的に scroll-behavior を auto に変更して「パッと」移動
        document.documentElement.style.scrollBehavior = 'auto';

        // 要素の位置を取得
        const rect = activeContent.getBoundingClientRect();

        // `.header-wrap` の高さを取得
        const headerHeight = document.querySelector('.header-wrap')?.offsetHeight || 0;

        // スクロール位置を調整（オフセット分だけスクロール）
        window.scrollTo({
          top: rect.top + window.pageYOffset - headerHeight - 20,
          behavior: 'auto', // 「パッと」移動させるために `auto` を使用
        });

        // スクロール後に再度 smooth に戻す
        setTimeout(() => {
          document.documentElement.style.scrollBehavior = 'smooth';
        }, 0);
      }
    }
  };

  const initialTab = getTabFromURL();
  activateTab(initialTab);

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const tabId = btn.dataset.tab;
      if (!btn.classList.contains('active')) {
        activateTab(tabId, shouldUseHistory); // 履歴保持が必要なページのみtrue
      }
    });
  });

  // ブラウザバック/フォワード対応（main.guideがある場合のみ）
  if (shouldUseHistory) {
    window.addEventListener('popstate', () => {
      const hash = window.location.hash.slice(1); // '#' を除去
      const tabId = hash || getTabFromURL();
      activateTab(tabId, false); // 履歴には追加しない
    });
  }
};
